import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { ListItemButton, ListItemText } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase,
  faHouseLaptop,
  faArrowRightFromBracket,
  faListCheck,
  faPeopleGroup,
  faUserPlus,
  faUserXmark,
  faDesktop,
  faHouse,
  faUsers,
  faFileInvoiceDollar,
  faThumbsUp,
  faFileContract,
  faSuitcase,
  faUpload,
  faChartLine,
} from '@fortawesome/free-solid-svg-icons';
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

import {
  faClock,
  faUser,
  faCalendarCheck,
} from '@fortawesome/free-regular-svg-icons';

const iconMapping = {
  'Master Data': faDatabase,
  Leaves: faArrowRightFromBracket,
  WFH: faHouseLaptop,
  Normalization: faClock,
  Timings: faClock,
  Tasks: faListCheck,
  Teams: faPeopleGroup,
  People: faUser,
  'Work Reports': faCalendarCheck,
  Manage: faSuitcase,
  'Response Time': faChartLine,
  Users: faUsers,
  'External Hours': NaturePeopleIcon,
  'Client Office Hours': BusinessCenterIcon,
  'Remote Office Hours': BusinessCenterIcon,
  'Leave Requests': faArrowRightFromBracket,
  'WFH Quota Requests': faHouseLaptop,
  'WFH Requests': faHouseLaptop,
  'Employee Onboarding': faUserPlus,
  'Employee Offboarding': faUserXmark,
  Assets: faDesktop,
  Dashboard: faHouse,
  'Employee Privileges': faUser,
  'Quarterly Casual Leave': faCalendarCheck,
  Reports: faFileInvoiceDollar,
  'Project Reports': faFileInvoiceDollar,
  'Employee Summary': faUsers,
  'Approve Skill': faThumbsUp,
  Projects: faFileContract,
  'Bulk Upload': faUpload,
  'Employee CSV': faUpload,
};

export default function MenuListComponent(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const peopleId = useSelector((state) => state.peopleState.id);

  const onDestroy = () => {
    if (!peopleId) return;
    dispatch({
      type: 'PEOPLE_PAGE',
      data: {
        id: '',
        display: true,
      },
    });
  };

  const navigateRoute = (routePath) => {
    if (!routePath) return;
    if (routePath === '/user-leaves') {
      dispatch({
        type: 'RESET-TAB',
      });
    }
    navigate(routePath);
    if (props.hideMenu) props.hideMenu(false);
    onDestroy();
  };

  const renderIcon = (title) => {
    if (iconMapping[title]) {
      if (title === 'External Hours') {
        return <NaturePeopleIcon color="primary" />;
      }
      if (title === 'Client Office Hours' || title === 'Remote Office Hours') {
        return <BusinessCenterIcon color="primary" />;
      }
      return (
        <FontAwesomeIcon
          icon={iconMapping[title]}
          size="lg"
          style={{ color: '#4D6CD9' }}
        />
      );
    }
    return (
      <FontAwesomeIcon
        icon={faDatabase}
        style={{ color: '#003566' }}
        size="sm"
      />
    );
  };

  const isPathActive = (path) =>
    path &&
    (location.pathname === path || location.pathname.startsWith(`${path}/`));

  const renderMenuItem = (page, nested = false) => {
    const isActive = isPathActive(page.path);
    return (
      <ListItem
        key={page.key}
        disablePadding
        sx={{
          pl: nested ? 2.5 : 0,
          backgroundColor: isActive ? '#c3c3c3' : 'transparent',
        }}
      >
        <ListItemButton disableRipple onClick={() => navigateRoute(page.path)}>
          <ListItemIcon sx={{ minWidth: nested ? 32 : 40 }}>
            {renderIcon(page.title)}
          </ListItemIcon>
          <ListItemText
            primary={page.title}
            primaryTypographyProps={{
              fontSize: nested ? '0.875rem' : '1rem',
            }}
          />
        </ListItemButton>
      </ListItem>
    );
  };

  return (
    <List sx={{ width: '100%', overflowY: 'auto', pb: 2 }}>
      {(props.sideMenuRoutes || []).map((page, index) => {
        if (page.children?.length) {
          const childActive = page.children.some((child) =>
            isPathActive(child.path),
          );
          return (
            <div key={page.key}>
              <ListItem
                disablePadding
                sx={{
                  backgroundColor: childActive ? '#e8e8e8' : 'transparent',
                }}
              >
                <ListItemButton
                  disableRipple
                  onClick={() => navigateRoute(page.children[0]?.path)}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    {renderIcon(page.title)}
                  </ListItemIcon>
                  <ListItemText primary={page.title} />
                </ListItemButton>
              </ListItem>
              <List component="div" disablePadding>
                {page.children.map((child) => renderMenuItem(child, true))}
              </List>
              {index !== props.sideMenuRoutes.length - 1 ? <Divider /> : null}
            </div>
          );
        }

        return (
          <div key={page.key}>
            {renderMenuItem(page)}
            {index !== props.sideMenuRoutes.length - 1 ? <Divider /> : null}
          </div>
        );
      })}
    </List>
  );
}
